import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { RsCmsServicesModule } from '@digital-platform/rs-cms/services';
import { NavComponent } from '@digital-platform/rs-cms/ui';
import {
  AccountDropdownButtonComponent,
  AccountHeaderComponent,
} from '@digital-platform/rs-header/ui';
import {
  AccountHeaderResolver,
  getAccountHeaderGuard,
} from '@digital-platform/rs-header-services';
import { FeatureFlagGuard } from '@digital-platform/rs-shared/guards';
import { AlertBannerComponent } from './alert-banner/alert-banner.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  imports: [
    AccountDropdownButtonComponent,
    AlertBannerComponent,
    AccountHeaderComponent,
    NavComponent,
    CommonModule,
    FormsModule,
    RsCmsServicesModule,
    RouterModule.forChild([
      // {
      //   path: '',
      //   component: HeaderComponent,
      //   children: [
      //     {
      //       path: '',
      //       resolve: {
      //         accountHeaderItems: AccountHeaderResolver,
      //       },
      //       data: {
      //         featureFlags: 'waste-profiling',
      //         path: 'profiling',
      //       },
      //       canMatch: [FeatureFlagGuard, getAccountHeaderGuard('/profiling')],
      //       component: AccountHeaderComponent,
      //       runGuardsAndResolvers: 'always',
      //     },
      //     {
      //       path: '',
      //       resolve: {
      //         accountHeaderItems: AccountHeaderResolver,
      //       },
      //       data: {
      //         // add feature flag for reports pillar
      //         path: 'reporting',
      //       },
      //       canMatch: [getAccountHeaderGuard('/reporting')],
      //       component: AccountHeaderComponent,
      //       runGuardsAndResolvers: 'always',
      //     },
      //   ],
      // },
      {
        path: '**',
        component: HeaderComponent,
      },
    ]),
  ],
  declarations: [HeaderComponent],
  providers: [TranslateService],
})
export class RsHeaderFeatureHeaderModule {}
